import React, {Component} from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import {Map} from "immutable";
import {ProgressBar} from "@blueprintjs/core";
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";

// Components
import PurchaseInvoiceDetail from "./PurchaseInvoiceDetail";
import PurchaseInvoiceFiles from './PurchaseInvoiceFiles';
import DeleteDialog from '../../../components/dialogs/DeleteDialog';

// Actions
import {
    getPurchaseInvoice,
    updatePurchaseInvoice,
    changePurchaseInvoiceStatus,
    uploadPurchaseInvoiceFiles,
    downloadPurchaseInvoiceFile,
    deletePurchaseInvoiceFile,
    deletePurchaseInvoice,
    cleanPurchaseInvoices
} from "../../../actions/purchase-invoices";
import {addNotification} from "../../../actions/notifications";


class PurchaseInvoiceTabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabIndex: this.getSelectedIndex(),
            editMode: false,
            canSubmit: false,
            status: '',
            // modal
            modalIsOpen: false,
            modalType: null
        };

        this.getSelectedIndex = this.getSelectedIndex.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }
    componentDidMount() {
        this.props.getPurchaseInvoice(this.props.match.params.purchaseInvoiceId);
    }
    componentWillUnmount() {
        this.props.cleanPurchaseInvoices();
    }

    // Tab handlers
    getSelectedIndex() {
        const {purchaseInvoiceId} = this.props.match.params;

        // Check if any child route is active. As last step, check if principal route is active to assign default tab index.
        switch (this.props.history.location.pathname) {
            case '/compras/facturas/' + purchaseInvoiceId + '/detalle':
                return 0;
            case '/compras/facturas/' + purchaseInvoiceId + '/ficheros':
                return 1;
            default:
                return 0;
        }
    }
    handleTabChange(index, lastIndex, event) {
        const {purchaseInvoiceId} = this.props.match.params;
        let route = '';

        switch (index) {
            case 0:
                route = '/compras/facturas/' + purchaseInvoiceId + '/detalle';
                break;
            case 1:
                route = '/compras/facturas/' + purchaseInvoiceId + '/ficheros';
                break;
            default:
                break;
        }

        this.props.history.push(route);
        this.setState({
            tabIndex: this.getSelectedIndex()
        });
    }

    // PurchaseInvoiceDetail handlers
    handleEditClick = () => {
        this.setState({
            editMode: true
        });
    };
    handleCancelClick = () => {
        this.child.updatePurchaseInvoicesState();
        this.setState({
            editMode: false,
            canSubmit: false
        });
    };
    handleSaveClick = () => {
        this.child.updatePurchaseInvoice();
        this.setState({
            editMode: false
        });
    };
    canSubmit = (canSubmit) => {
        this.setState({ canSubmit })
    };

    // Modal handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false
        })
    };

    render() {
        const { tabIndex, editMode, canSubmit } = this.state;

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'deleteDialog':
                    modal = {
                        width: 'medium',
                        title: 'Borrar factura de compra',
                        body: (
                            <DeleteDialog
                                text={ this.props.purchaseInvoice.get('invoice_code') }
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="delete"
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={ () => {
                                        this.props.deletePurchaseInvoice(this.props.purchaseInvoice.get('_id'));
                                        this.closeModal();
                                        this.props.history.push('/compras/facturas');
                                    }}
                                >
                                    {'Borrar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (

            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/compras/resumen">Compras</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/compras/facturas">Facturas</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>{ this.props.purchaseInvoice.get('invoice_code') }</strong>
                            </li>
                        </ol>
                    </div>
                    { this.props.uploadProgress.get('isUploading')
                        ? <div className="col d-flex align-items-center justify-content-end">
                            <ProgressBar
                                intent="PRIMARY"
                                value={ this.props.uploadProgress.get('percent') } />
                        </div>
                        : null
                    }
                    { tabIndex === 0
                        ? (
                            <div className="col d-flex align-items-center justify-content-end">
                                {!editMode
                                    ? <div className="title-action">
                                        { this.props.purchaseInvoice.get('can_delete')
                                                ? <button
                                                    className="btn btn-danger"
                                                    onClick={ () => this.openModal('deleteDialog') }
                                                >Borrar</button>
                                                : null
                                        }
                                        <button className="btn btn-custom" onClick={this.handleEditClick}>Editar</button>
                                    </div>
                                    : <div className="title-action">
                                        <button className="btn btn-cancel" onClick={this.handleCancelClick}>Cancelar</button>
                                        <button
                                            className="btn btn-primary"
                                            onClick={this.handleSaveClick}
                                            disabled={!canSubmit}
                                        >Guardar
                                        </button>
                                    </div>
                                }
                            </div>
                        ) : ''
                    }
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="tabs-container">
                                { this.props.purchaseInvoice.get('_id')
                                    ? (
                                <Tabs
                                    selectedIndex={tabIndex}
                                    onSelect={this.handleTabChange}
                                    selectedTabPanelClassName="active show"
                                >
                                    <TabList className="nav nav-tabs">
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 0})}>Detalle</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 1})}>Ficheros</Link>
                                        </Tab>
                                    </TabList>
                                    <div className="tab-content">
                                        <TabPanel className="tab-pane">
                                            <PurchaseInvoiceDetail
                                                onRef={ref => (this.child = ref)}
                                                editMode={this.state.editMode}
                                                canSubmit={this.canSubmit}
                                                purchaseInvoice={this.props.purchaseInvoice}
                                                updatePurchaseInvoice={this.props.updatePurchaseInvoice}
                                                changePurchaseInvoiceStatus={this.props.changePurchaseInvoiceStatus}
                                            />
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            <PurchaseInvoiceFiles
                                                purchaseInvoice={this.props.purchaseInvoice}
                                                uploadPurchaseInvoiceFiles={this.props.uploadPurchaseInvoiceFiles}
                                                uploadProgress={this.props.uploadProgress}
                                                downloadPurchaseInvoiceFile={this.props.downloadPurchaseInvoiceFile}
                                                deletePurchaseInvoiceFile={this.props.deletePurchaseInvoiceFile}
                                                addNotification={this.props.addNotification}
                                            />
                                        </TabPanel>
                                    </div>
                                </Tabs>
                                        )
                                        : null
                                    }
                            </div>
                        </div>
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const purchaseInvoiceReducer = state.purchaseInvoices;

    // PurchaseInvoice
    let purchaseInvoice = purchaseInvoiceReducer.get('payload') || Map({});

    if (!(purchaseInvoice instanceof Map)) {
        purchaseInvoice = Map({})
    }

    // Upload Progress
    const uploadProgress = Map({
        isUploading: purchaseInvoiceReducer.get('isUploading') || false,
        percent: purchaseInvoiceReducer.get('percent') || 0
    });

    return {
        purchaseInvoice,
        uploadProgress
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPurchaseInvoice: (purchaseInvoiceId) => dispatch(getPurchaseInvoice(purchaseInvoiceId)),
        updatePurchaseInvoice: (purchaseInvoiceId, purchaseInvoice) => dispatch(updatePurchaseInvoice(purchaseInvoiceId, purchaseInvoice)),
        changePurchaseInvoiceStatus: (purchaseInvoiceId, status) => dispatch(changePurchaseInvoiceStatus(purchaseInvoiceId, status)),
        uploadPurchaseInvoiceFiles: (purchaseInvoiceId, files) => dispatch(uploadPurchaseInvoiceFiles(purchaseInvoiceId, files)),
        downloadPurchaseInvoiceFile: (purchaseInvoiceId, fileId) => dispatch(downloadPurchaseInvoiceFile(purchaseInvoiceId, fileId)),
        deletePurchaseInvoiceFile: (purchaseInvoiceId, fileId) => dispatch(deletePurchaseInvoiceFile(purchaseInvoiceId, fileId)),
        deletePurchaseInvoice: (purchaseInvoiceId) => dispatch(deletePurchaseInvoice(purchaseInvoiceId)),
        cleanPurchaseInvoices: () => dispatch(cleanPurchaseInvoices()),
        addNotification: (notification) => dispatch(addNotification(notification))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseInvoiceTabs);



// WEBPACK FOOTER //
// ./src/containers/purchases/invoices/PurchaseInvoiceTabs.js